<template>
  <div
    class="pt-1 flex flex-wrap"
    :class="accessories ? 'no-pad' : 'mb-6'"
    id="offer-container"
  >
    <div
      :key="offer"
      v-for="(offer_info, offer) in offersToShow"
      :class="
        `w-12/12 flex flex-col justify-start p-1 md:p-2 offer !text-left ${
          offer_info.offerType === activeOffer.offerType
            ? 'active'
            : ''
        }`
      "
      :style="`order: ${offer_info.offerKey === activeProductInfo.defaultOffering || offer_info.offerType.includes('Safety') ? '-1' : '0'}`"
      :value="offer"
      @click="
        setActiveOfferKey(offer_info.offerKey);
        addOffer(offer_info.offerKey);
        $emit('license-change', offer);
        scrollTo();
      "
    >
      <h4 class="bold text-blue-dark text-2xl mb-1/2 mt-0 leading-none">
        {{ offer_info.offerType }}
      </h4>
      <template v-if="['Hardware', 'Hardware-B'].includes(offer_info.offerKey)">
        <p class="mt-0">{{ currencySymbol.toUpperCase() }}{{calculateTotalPrice(activeProductInfo.offerings[offer].salesPrice).toFixed(2)}}</p>
      </template>
      <template
        v-else-if="calculateTotalPrice(activeProductInfo.offerings[offer].salesPrice).toFixed(2) !== calculateTotalPrice(activeProductInfo.offerings[offer].listPrice).toFixed(2)"
      >
        <p class="mt-0">
          <span class="line-through"
            >{{ currencySymbol.toUpperCase() }}{{ calculateTotalPrice(activeProductInfo.offerings[offer].listPrice).toFixed(2) }}</span
          >
          <span class=""
            >{{ currencySymbol.toUpperCase() }}{{calculateTotalPrice(activeProductInfo.offerings[offer].salesPrice).toFixed(2)}} / {{ activeProductInfo.offerings[offer].defaultPaymentTerm }}</span
          >
        </p>
      </template>
      <template v-else>
        <p class="mt-0">{{ currencySymbol.toUpperCase() }}{{calculateTotalPrice(activeProductInfo.offerings[offer].salesPrice).toFixed(2)}} / {{ activeProductInfo.offerings[offer].defaultPaymentTerm }}</p>
      </template>
      <p class="text-blue-dark font-normal subtext mt-1/2">
        {{offer_info.offerSubtext}}
      </p>
    </div>
    <div class="text-center">
      <p
        class="padding-top disclaimer bold"
        v-if="activeOfferKey === 'Hardware'"
      >
        {{ webstoreContent.webstoreBody["hardware_disclaimer"] }}
      </p>
    </div>
  </div>
</template>
<script>
import { WebstoreResources } from '../../../../mixins/webstore-resources';
import { analyticsTrack } from "../../../../plugins/segment";
export default {
  mixins: [WebstoreResources],
  props: {
    accessories: {
      required: false,
      type: Boolean,
    }
  },
  methods: {
    addOffer(offerKey) {
      analyticsTrack("Offer Selected", {
        offer: offerKey,
        productKey: this.activeProductKey,
      });
    },

    scrollTo() {
      this.$emit('scroll-to', 1)
    }
  }
};
</script>
<style lang="scss" scoped>
  @media (min-width: 736px) {
    #offer-container {
      padding-bottom: 500px;
    }
  }
  
  #offer-container .subtext {
    font-weight: 400;
    font-size: 16px;
    line-height: 140%;
    color: #00263E;
  }

  #offer-container p {
    font-weight: 450;
    font-size: 18px;
    line-height: 140%;
    color: #00263E;
  }

  .offer {
    cursor: pointer;
    font-size: 18px;
    font-weight: bold;
    text-align: center;
    line-height: 20px;
    background: #ffffff;
    border: 3px solid #ffffff;
    box-sizing: border-box;
    box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.1);
    border-radius: 14px;
    min-height: 65px;
    margin-bottom: 25px;
  }

  .active {
    border: 3px solid #0384fb;
  }

  .no-pad {
    padding-bottom: 0 !important;
  }
</style>
